module.exports = __webpack_public_path__ + "static/media/close-tooltip.f1aef602.svg";